import React from 'react';

import VRWelcomePage0 from '@Resources/game/guides/welcome/vr/page0.png';
import VRWelcomePage1 from '@Resources/game/guides/welcome/vr/page1.png';
import VRWelcomePage2 from '@Resources/game/guides/welcome/vr/page2.png';
import VRWelcomePage3 from '@Resources/game/guides/welcome/vr/page3.png';
import VRWelcomePage4 from '@Resources/game/guides/welcome/vr/page4.png';
import VRWelcomePage5 from '@Resources/game/guides/welcome/vr/page5.png';
import { Box } from '@mui/material';

const images = [
  VRWelcomePage0,
  VRWelcomePage1,
  VRWelcomePage2,
  VRWelcomePage3,
  VRWelcomePage4,
  VRWelcomePage5,
];

export default React.memo(() => {
  return (
    <Box sx={{ height: 0, width: 0 }}>
      {images.map((image, i) => {
        return <img key={i} src={image} alt={""} style={{ opacity: 0, height: 0, width: 0 }} />;
      })}
    </Box>
  );
});
